import { Link, NavLink } from 'react-router-dom';
import { IconBrandTelegram, IconInfoCircle } from '@tabler/icons-react';
import { TELEGRAM_CHANNEL_URL } from '../../config/contacts';
import LogoBrand from '../ui/LogoBrand';
import { track } from '../../utils/analytics';
import './GuestTopNav.scss';

export default function GuestTopNav() {
    return (
        <header className="guest-top-nav">
            <Link to="/" className="guest-top-nav__logo">
                <LogoBrand variant="nav" />
            </Link>

            <div className="guest-top-nav__actions">
                <a
                    href={TELEGRAM_CHANNEL_URL}
                    className="guest-top-nav__icon-btn guest-top-nav__telegram"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Telegram-канал"
                >
                    <IconBrandTelegram size={20} stroke={1.5} />
                </a>
                <NavLink
                    to="/links"
                    onClick={() => track('nav_click', { target: '/links' })}
                    className={({ isActive }) =>
                        `guest-top-nav__icon-btn guest-top-nav__info${isActive ? ' guest-top-nav__info--active' : ''}`
                    }
                    aria-label="Информация"
                >
                    <IconInfoCircle size={20} stroke={1.5} />
                </NavLink>
                <Link
                    to="/login?redirect=/subscriptions"
                    className="guest-top-nav__login"
                    onClick={() => track('nav_click', { target: '/login' })}
                >
                    Войти
                </Link>
            </div>
        </header>
    );
}
